import { usePage, useWebsiteSettings } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useHeadingFontStyle = ({
  fontStyle,
  mobileFontStyle,
}: {
  fontStyle?: string
  mobileFontStyle?: string
}) => {
  const pageGlobalFontStyle = usePage(
    pageSelectors.getGlobalFontProperties,
  ).headingFontStyle

  const {
    fontStyle: websiteGlobalFontStyle,
    mobileFontStyle: globalMobileFontStyle,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const globalFontStyle = pageGlobalFontStyle || websiteGlobalFontStyle

  return {
    calculatedFontStyle: getCalculatedProperty({
      desktopProperty: fontStyle,
      mobileProperty: mobileFontStyle,
      globalDesktopProperty: globalFontStyle,
      globalMobileProperty: globalMobileFontStyle,
    }),
    globalFontStyle,
    globalMobileFontStyle: globalMobileFontStyle || globalFontStyle,
  }
}
